export default {
      id: "ic_not_found-usage",
      viewBox: "0 0 164 161",
      url: "/" + "images/icons.3.109.2.svg#ic_not_found-usage",
      toString: function () {
        return this.url;
      }
    }